import { render, staticRenderFns } from "./StartupsAdvancedGrid.vue?vue&type=template&id=136682d5&scoped=true&"
import script from "./StartupsAdvancedGrid.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupsAdvancedGrid.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136682d5",
  null
  
)

export default component.exports